import script from "./news.list.vue?vue&type=script&setup=true&lang=js"
export * from "./news.list.vue?vue&type=script&setup=true&lang=js"

import "./news.list.vue?vue&type=style&index=0&id=0b31f81b&lang=less"

const __exports__ = script;

export default __exports__